import commissions from 'Agent/Commissions/ducks/commission';
import schedules from 'Agent/Commissions/ducks/commissionSchedules';

export default {
  commissions,
  schedules,
};
